<app-campaign-details
  [ngoId]="ngoId"
  [campaignId]="campaignId"
  [projectId]="projectId"
  [showDonationSummary]="false"
  [showFundraisers]="false"
  ></app-campaign-details>
